import axios from 'axios';

// 基础配置
// 使用相对路径，通过Nginx代理访问后端API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const API_PREFIX = '/api/v1/mock-interview';

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const user = localStorage.getItem('user');
    if (user) {
      try {
        const userData = JSON.parse(user);
        if (userData.id) {
          config.headers['X-User-Id'] = userData.id;
        }
      } catch (e) {
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const AIReferenceAPI = {
  /**
   * 生成AI参考回答
   * @param {Object} data - 请求数据
   * @param {string} data.job_title - 职位名称
   * @param {string} data.company_name - 公司名称
   * @param {string} data.resume_text - 简历内容
   * @param {Array} data.interview_questions - 面试题目列表
   * @param {string} data.interview_record - 当前面试记录
   * @param {string} data.current_question - 当前面试官问题
   * @param {string} [data.interview_language] - 回答语言（chinese/english）
   * @returns {Promise} API响应
   */
  generateReferenceAnswer: async (data) => {
    try {
      const response = await api.post(`${API_PREFIX}/ai-reference`, data);
      if (response.status === 200 && response.data) {
        if (response.data.success) {
          return response.data;
        } else {
          throw new Error(`AI参考回答生成失败: ${response.data.error || '未知错误'}`);
        }
      } else {
        throw new Error(`API响应异常: 状态码 ${response.status}`);
      }
      
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data?.detail || error.response.data?.error || error.response.statusText;
        throw new Error(`服务器错误: ${errorMessage}`);
      } else if (error.request) {
        throw new Error('网络连接失败，请检查网络连接');
      } else {
        throw new Error(`请求失败: ${error.message}`);
      }
    }
  }
};
